module.exports = __webpack_public_path__ + "static/media/startpage.89bfbeef.jpg";